__turbopack_context__.v({
  "body": "LegCard-module__CQ_Wda__body",
  "bodyBelowGallery": "LegCard-module__CQ_Wda__bodyBelowGallery",
  "content": "LegCard-module__CQ_Wda__content",
  "detailRow": "LegCard-module__CQ_Wda__detailRow",
  "divider": "LegCard-module__CQ_Wda__divider",
  "greenTag": "LegCard-module__CQ_Wda__greenTag",
  "greyTag": "LegCard-module__CQ_Wda__greyTag",
  "mode": "LegCard-module__CQ_Wda__mode",
  "modeArrow": "LegCard-module__CQ_Wda__modeArrow",
  "modes": "LegCard-module__CQ_Wda__modes",
  "route": "LegCard-module__CQ_Wda__route",
  "routeCity": "LegCard-module__CQ_Wda__routeCity",
  "routeConnector": "LegCard-module__CQ_Wda__routeConnector",
  "routeDivider": "LegCard-module__CQ_Wda__routeDivider",
  "title": "LegCard-module__CQ_Wda__title",
});
